import { fetch } from '../request'

export const getXihePreviewVideo = (params: { generate_record_id: number }) => {
  return fetch('/youyan/generate_record/get_xihe_preview_video', {
    method: 'GET',
    params,
  })
}
